
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genre/[[...keywords]]",
      function () {
        return require("private-next-pages/genre/[[...keywords]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genre/[[...keywords]]"])
      });
    }
  